export default __webpack_public_path__ + "3a430da40be4be2a93d39a22d67800b3.png";